<template>
  <div>
    <div class="row mb-5">
      <div class="col-12">
        <label>
          {{$t('CONTENT.payments.payment_lease_rate')}}:
          <span class="b-form__required">*</span>
        </label>
        <numeric class="b-numeric" controls :min="0" :max="1000000000000" v-model="newRate"></numeric>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-12">
        <checkbox class="b-checkbox" v-model="needToUpdateDiscountRate">Cтавка дисконтирования пересматривается</checkbox>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label>
        {{$t('CONTENT.events.newFirstIndexationDate')}}:
      </label>
        <datepicker class="b-datepicker" v-model="newFirstIndexationDate" placeholder="" :formatter="datepickerFormat"  :disabled-date="disabledDate"/>
      </div>
    </div>
  </div>
</template>

<script>
import IndexationRefinement from "../../models/commands/IndexationRefinement";
import datepickerFormat from '@/mixins/datepickerFormat.mixin';
import DateWithoutTimeAPI from "../../../../api/DateWithoutTimeAPI";
import dateConverter from "../../../../utils/converters/date.converter";

export default {
  props: {
    paymentParams: {
      type: Object,
      required: true
    }
  },
  mixins: [datepickerFormat],
  data() {
    return {
      newRate: 0,
      needToUpdateDiscountRate: false,
      newFirstIndexationDate: null,
      validationErrors: [],
    };
  },
  async created() {
    if(this.paymentParams.indexation.firstIndexationDate) {
      const convertedCurrentFirstIndexationDate = encodeURIComponent(
        this.paymentParams.indexation.firstIndexationDate
      );
      let newDate = await new DateWithoutTimeAPI().addMonths(
        convertedCurrentFirstIndexationDate,
        12
      );

      this.newFirstIndexationDate = dateConverter.convertToDate(newDate);
    }
  },
  methods: {
    cancel() {
      this.newRate = 0;
      this.needToUpdateDiscountRate = false;
      this.newFirstIndexationDate = null;
    },

    save() {
      let convertedDate = null;
      if(this.newFirstIndexationDate !== null) {
        convertedDate = dateConverter.convertToString(this.newFirstIndexationDate)
      }

      const command = new IndexationRefinement(
        this.paymentParams.idInDB,
        this.newRate,
        this.needToUpdateDiscountRate,
        convertedDate
      );
      this.$store.commit("eventRegistryPlugin/addOrUpdateCommand", command);
      return true;
    },

    disabledDate(date) {
      const startDate = this.paymentParams.startDate
      if(startDate === null || startDate === '') return false
      return date < dateConverter.convertToDate(startDate)
    }
  }
};
</script>

<style>
</style>
